import { useEffect, useState } from "react";

/** Numeric cell input committing on blur/Enter. `scale` converts display<->stored (e.g. 100 for %). */
export function NumCell({ value, onCommit, className = "", testId, scale = 1, placeholder = "" }) {
  const display = value === null || value === undefined || value === "" ? "" : Math.round(Number(value) * scale * 100) / 100;
  const [v, setV] = useState(display);
  useEffect(() => { setV(display); }, [display]);
  const commit = () => {
    const n = v === "" ? null : Number(v) / scale;
    if (n !== (value ?? null)) onCommit(n);
  };
  return (
    <input
      data-testid={testId}
      type="number"
      step="any"
      placeholder={placeholder}
      className={`cell-input ${className}`}
      value={v}
      onChange={(e) => setV(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
    />
  );
}

export function TextCell({ value, onCommit, className = "", testId }) {
  const [v, setV] = useState(value ?? "");
  useEffect(() => { setV(value ?? ""); }, [value]);
  return (
    <input
      data-testid={testId}
      className={`cell-input text-left ${className}`}
      value={v}
      onChange={(e) => setV(e.target.value)}
      onBlur={() => v !== value && onCommit(v)}
      onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
    />
  );
}
